import * as React from 'react'
import styled from 'styled-components'
import Svg from './Svg'

function BaseComponent(props: any) {
  return (
    <Svg
      width={15}
      height={15}
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.5.85a.5.5 0 00-.5.5v2.172a.5.5 0 101 0v-1.65a5.65 5.65 0 11-4.81 1.974.5.5 0 10-.762-.647A6.65 6.65 0 107.5.85zm-.76 7.23L4.224 4.573a.25.25 0 01.348-.348L8.081 6.74a.96.96 0 11-1.34 1.34z"
        fill="currentColor"
      />
    </Svg>
  )
}

const SvgTimer = styled(BaseComponent)`
  outline: none;
`
export default SvgTimer
